import { v4 as uuidv4 } from "uuid";
import { makeAutoObservable } from "mobx";
import { runInAction } from "mobx";
class MinMaxStore {
    id = uuidv4();
    rootStore;
    start = null;
    end = null;
    minStartRange = 0;
    minEndRange = 0;
    maxStartRange = 0;
    maxEndRange = 0;
    constructor(rootStore, fieldKey) {
        this.rootStore = rootStore;
        makeAutoObservable(this);
    }
    setRange({ name, value }) {
        runInAction(() => {
            this[name] = value === "null" ? null : Number(value);
        });
    }
    setminmaxdefault({ minStartRange, minEndRange, maxStartRange, maxEndRange }) {
        runInAction(() => {
            this.minStartRange = Number(minStartRange);
            this.minEndRange = Number(minEndRange);
            this.maxStartRange = Number(maxStartRange);
            this.maxEndRange = Number(maxEndRange);
        });
    }
    getRange({ name }) {
        return this[name];
    }
    clearMe() {
        runInAction(() => {
            this.start = null;
            this.end = null;
            this.minStartRange = 0;
            this.minEndRange = 0;
            this.maxStartRange = 0;
            this.maxEndRange = 0;
        });
    }
}
export default MinMaxStore;
